"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-left: auto;\n  width: 1.3rem;\n  height: auto;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * Added to support text resizing
 */
var Img = _styledComponents.default.img(_templateObject());
/**
 * alt="" hides the decorative icons from assistive technology.
 */


var ActionIconItem = function ActionIconItem(_ref) {
  var actionIcon = _ref.actionIcon;
  return /*#__PURE__*/_react.default.createElement(Img, {
    src: actionIcon,
    alt: "",
    "data-testid": "action-icon"
  });
};

ActionIconItem.propTypes = {
  /** Customizable icon that indicates this section is a link and is not expandable/collapsible */
  actionIcon: _propTypes.default.string
};
ActionIconItem.defaultProps = {
  actionIcon: null
};
var _default = ActionIconItem;
exports.default = _default;